export default __webpack_public_path__ + "a0223a6b35d400c3d1ca16483822d91d.png";